import { useDesignMaxTheme } from "@/packages";
import { Center, Text } from "@chakra-ui/react";
import { FONT } from "@styles/common";
import { type PieceBannerProps } from "./pieceBanner.type";

export const PieceBanner = ({ imgUrl, name, title }: PieceBannerProps) => {
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    return (
        <Center
            w="100%"
            h={isMobile ? "480px" : "640px"}
            background={`url(${imgUrl}) no-repeat center/cover`}
            flexDir="column"
            rowGap={isMobile ? "8px" : "16px"}
        >
            <Text
                color={COLORS.white}
                sx={isMobile ? { ...FONT("cormorant", 52, 500) } : { ...FONT("cormorant", 32, 500) }}
            >
                {name && name.en} {title.main}
            </Text>
            <Text color={COLORS.white} sx={{ ...FONT("notoSerif", 16, 500) }}>
                {name && name.kr} {title.sub}
            </Text>
        </Center>
    );
};
